"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ClayDropDownDivider = function ClayDropDownDivider() {
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "dropdown-divider",
    role: "separator"
  });
};

var _default = ClayDropDownDivider;
exports.default = _default;